<div class="row" style="margin: 0; padding: 0 0.625rem 0 0">
  @if (!isLoading && !noData) {
    <div class="grid">
      <!--  -->
      <div class="UsageList">
        <div class="tHeadRow" style="border-bottom: none">
          <div class="tHead t70 nameCol">Name</div>
          <div class="tHead t20 tRight">Total Usage<span class="usage-type" data-context="UsageType"></span></div>
        </div>
        <div class="usageByGateawy row" id="UsageListData" style="padding: 0rem">
          <cdk-virtual-scroll-viewport [itemSize]="25" class="scroll-viewport">
            <div
              (click)="setItemFilter(item.name)"
              *cdkVirtualFor="let item of items; let i = index"
              [ngClass]="{ selected: currentItemFilter === item.name }"
              class="dataRow"
              >
              <div class="tRow filterItem" id="item_{{ i }}">
                <div class="tCol tLeft t70">
                  <span [matTooltip]="nameTruncateLength > 0 && item.name?.length > nameTruncateLength ? item.name : ''"
                        matTooltipPosition="above">
                    {{ nameTruncateLength > 0 ? (item.name | truncate: nameTruncateLength) : item.name }}
                  </span>
                </div>
                <div class="tCol t30 tRight secondcol">{{ item.usage | tobytes: true }}</div>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    </div>
  }
</div>
@if (!isLoading && noData) {
  <div class="noDataZiti">No Data</div>
}
@if (isLoading) {
  <div style="margin-top: 9.375rem">
    <app-loader [isLoading]="isLoading"></app-loader>
  </div>
}
